import PropTypes from "prop-types";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ImgLogo } from "@assets/svg/logo.svg";

/**
 * 헤더 로고. 고객 CI 로고가 설정돼 있으면 그것을, 없으면 기본 로고를 그린다.
 *
 * @param {Object} props
 * @param {string|null|undefined} props.imgSrc - useHeaderTheme 의 logoSrc.
 *   undefined 면 설정이 아직 안 온 것이고, null 이나 빈 문자열이면 커스텀 로고가 없는 것이다.
 */
const Logo = ({ to, imgSrc, className, fill }) => {
    const [failedSrc, setFailedSrc] = useState(null);
    const hasFailed = !!imgSrc && failedSrc === imgSrc;

    const renderLogo = () => {
        if (imgSrc === undefined) return null;
        if (!imgSrc || hasFailed) return <ImgLogo fill={fill} />;

        return <img src={imgSrc} alt="logo" style={{ maxHeight: 24 }} onError={() => setFailedSrc(imgSrc)} />;
    };

    return (
        <h1>
            <Link className={className} to={to}>
                {renderLogo()}
            </Link>
        </h1>
    );
};

Logo.propTypes = {
    to: PropTypes.string,
    imgSrc: PropTypes.string,
    className: PropTypes.string,
    fill: PropTypes.string,
};

Logo.defaultProps = {};

export default Logo;
